/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DIHTotemPrice
 */
export interface DIHTotemPrice {
    /**
     * 
     * @type {string}
     * @memberof DIHTotemPrice
     */
    indicativePriceDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DIHTotemPrice
     */
    marginType?: string;
    /**
     * 
     * @type {number}
     * @memberof DIHTotemPrice
     */
    marginValue?: number;
}

export function DIHTotemPriceFromJSON(json: any): DIHTotemPrice {
    return DIHTotemPriceFromJSONTyped(json, false);
}

export function DIHTotemPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DIHTotemPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'indicativePriceDate': !exists(json, 'indicativePriceDate') ? undefined : json['indicativePriceDate'],
        'marginType': !exists(json, 'marginType') ? undefined : json['marginType'],
        'marginValue': !exists(json, 'marginValue') ? undefined : json['marginValue'],
    };
}

export function DIHTotemPriceToJSON(value?: DIHTotemPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'indicativePriceDate': value.indicativePriceDate,
        'marginType': value.marginType,
        'marginValue': value.marginValue,
    };
}


